import React from 'react';
import axios from 'axios';
import * as types from '../store/Constants';
import history from '../services/history';
import { baseURL } from '../baseURL';
import { message } from 'antd';
// const baseURL = "https://beta-api.ezymigrate.co.nz/";
//const baseURL = baseURL;
let RefreshToken = true;
let SessionDeath = true;

let CallStack = [];
const onClose = () => {
  localStorage.clear();
  sessionStorage.clear();
  // history.location.push("/sign-up");
  window.location.reload();
};

// ─── Global session-expired handling ──────────────────────────────────────
// When the same account is signed in elsewhere, the server invalidates the
// active token. The next API call returns 401 and (typically) WITHOUT
// `code == 2` — so the existing refreshTokenData() path is skipped and the
// promise just rejects, leaving the UI silently broken (e.g. the email icon
// does nothing). The interceptor below catches every 401, lets the
// access-token-refresh case (code == 2) run as before, and for any other
// 401 logs the user out cleanly and redirects to /login.
let sessionExpiredHandled = false;

const isOnPublicRoute = () => {
  const p = (window.location && window.location.pathname) || '';
  return (
    p === '/login' ||
    p === '/login/' ||
    p.indexOf('/login/') === 0 ||
    p === '/sign-up' ||
    p === '/user-signup' ||
    p.indexOf('/forgot-password') === 0 ||
    p === '/admin-login' ||
    p === '/Home/PrivacyPolicy' ||
    p === '/c_q'
  );
};

const handleSessionExpired = (reasonMsg) => {
  if (sessionExpiredHandled) return;
  sessionExpiredHandled = true;

  // How long the toast stays on screen. The redirect waits for the toast
  // to finish so the user actually reads the message before being bounced.
  const TOAST_DURATION_SECONDS = 5;

  // Clear auth state immediately so any background calls fail fast and any
  // protected components stop rendering authed UI behind the toast.
  localStorage.clear();
  sessionStorage.clear();

  // Use `replace` so the user can't hit Back to return to the post-logout state.
  const goToLogin = () => window.location.replace('/login');

  let toastPromise;
  try {
    // antd's message.error returns a thenable that resolves when the toast
    // auto-closes — we use that to redirect strictly AFTER the message is
    // shown and dismissed (instead of racing it with a parallel setTimeout).
    toastPromise = message.error(
      reasonMsg || 'Your session has expired. Please log in again.',
      TOAST_DURATION_SECONDS
    );
  } catch (e) {
    // antd message may not be available very early in bootstrap.
  }

  if (toastPromise && typeof toastPromise.then === 'function') {
    toastPromise.then(goToLogin, goToLogin);
    // Safety net: if antd never resolves the toast (extension blocks it,
    // browser tab throttled, etc.) we still redirect after the duration + a
    // small buffer so the user isn't stuck on a half-broken authed page.
    setTimeout(goToLogin, TOAST_DURATION_SECONDS * 1000 + 500);
  } else {
    // No toast was shown — redirect immediately rather than hanging.
    goToLogin();
  }
};

// ─── Global forbidden (403) handling ──────────────────────────────────────
// 403 means the user IS authenticated but lacks permission for *this*
// specific action (e.g. trying to update a potential client without the
// update permission). We must NOT log them out — they should stay on the
// page and just see a clear toast explaining what happened. We also have
// to de-dupe because one click can fan out into several API calls that
// each 403, and we don't want a stack of identical toasts.
let forbiddenLastShownAt = 0;

const handleForbidden = (error) => {
  // 3-second window: any 403 within this window after the first one is a
  // burst from the same user action — suppress the duplicate toast.
  const now = Date.now();
  if (now - forbiddenLastShownAt < 3000) return;
  forbiddenLastShownAt = now;

  const data = error && error.response && error.response.data;
  // Backend message can arrive in many shapes — try them all before falling
  // back to a generic message.
  const apiMsg =
    (typeof data === 'string' && data) ||
    (data && (data.Detail || data.detail)) ||
    (data && (data.Message || data.message)) ||
    (data && (data.Title || data.title)) ||
    (data && data.error);
  const text =
    apiMsg ||
    "You don't have permission to perform this action. Please contact your administrator.";
  try {
    // Use a fixed key so antd itself collapses any duplicates that slip past
    // the time window (e.g. exactly-simultaneous parallel 403s).
    message.error({ content: text, duration: 5, key: 'api-forbidden' });
  } catch (e) {
    // antd not available; ignore — interceptor still rejects below.
  }
};

// Single global response interceptor — catches 401s and 403s regardless of
// whether the call went through `api.*`, `apiRefresh.*`, or any direct
// axios usage.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response && error.response.status;
    const code = error && error.response && error.response.data && error.response.data.code;
    if (status === 401 && !isOnPublicRoute()) {
      // code == 2 → access token expired, the existing refresh flow will
      // attempt to renew it. Don't interfere here; if the refresh itself
      // fails, its catch handler calls handleSessionExpired() too.
      if (code !== 2) {
        handleSessionExpired();
      }
    } else if (status === 403 && !isOnPublicRoute()) {
      // Permission-denied: surface a toast, but keep the user logged in and
      // on their current page. Still reject so callers can react if they
      // want (e.g. close a modal, revert optimistic UI).
      handleForbidden(error);
    }
    return Promise.reject(error);
  }
);
// ──────────────────────────────────────────────────────────────────────────
const api = {
  authLogin:
    (options, params = null) =>
    async (dispatch) => {
      const [success, failure] = options.types;
      const promise = (resolve, reject) => {
        axios({
          method: 'POST',
          url: `${baseURL}${options.url}`,
          data: params,
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((res) => {
            resolve(
              dispatch({
                type: success,
                payload: res.data,
              })
            );
          })
          .catch((err) => {
            reject(
              dispatch({
                type: failure,
                payload: err,
              })
            );
          });
      };

      return new Promise(promise);
    },
  getLogout: (options) => async (dispatch) => {
    const [success, failure] = options.types;
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }
      return axios({
        method: 'GET',
        url: `${baseURL}${options.url}`,

        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((res) => {
          resolve(
            dispatch({
              type: success,
              payload: res.data,
            })
          );
        })
        .catch((err) => {
          reject(
            dispatch({
              type: failure,
              payload: err,
            })
          );
        });
    };

    return new Promise(promise);
  },
  get: (options) => async (dispatch) => {
    const [success, failure] = options.types;

    const promise = (resolve, reject) => {
      let token = localStorage.getItem('token') || localStorage.getItem('admintoken');
      return axios({
        method: 'GET',
        url: `${baseURL}${options.url}`,
        headers: {
          Authorization: 'Bearer ' + token,
        },
        params: options.params || {}, // 👈 ADD THIS LINE (flexible query params)
      })
        .then((res) => {
          resolve(
            dispatch({
              type: success,
              payload: res.data,
            })
          );
        })
        .catch((err) => {
          refreshTokenData(err, 1, options, null);
          reject(
            dispatch({
              type: failure,
              payload: err,
            })
          );
        });
    };

    return new Promise(promise);
  },

  getFile: (options) => async (dispatch) => {
    const [success, failure] = options.types;
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }
      return axios({
        method: 'GET',
        url: `${baseURL}${options.url}`,
        responseType: 'blob',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((res) => {
          resolve(
            dispatch({
              type: success,
              payload: res.data,
            })
          );
        })
        .catch((err) => {
          reject(
            dispatch({
              type: failure,
              payload: err,
            })
          );
        });
    };
    return new Promise(promise);
  },
  postWithFileRes:
    (options, params = null) =>
    async (dispatch) => {
      const [success, failure] = options.types;
      const promise = (resolve, reject) => {
        var token = localStorage.getItem('token');
        if (token == null) {
          token = localStorage.getItem('admintoken');
        }
        axios({
          method: 'POST',
          url: `${baseURL}${options.url}`,
          data: params,
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
          },
        })
          .then((res) => {
            resolve(
              dispatch({
                type: success,
                payload: res.data,
              })
            );
          })
          .catch((err) => {
            refreshTokenData(err, 2, options, params);
            reject(
              dispatch({
                type: failure,
                payload: err,
              })
            );
          });
      };

      return new Promise(promise);
    },
  post:
    (options, params = null) =>
    async (dispatch) => {
      const [success, failure] = options.types;
      const promise = (resolve, reject) => {
        var token = localStorage.getItem('token');
        if (token == null) {
          token = localStorage.getItem('admintoken');
        }
        axios({
          method: 'POST',
          url: `${baseURL}${options.url}`,
          data: params,
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
          },
        })
          .then((res) => {
            resolve(
              dispatch({
                type: success,
                payload: res.data,
              })
            );
          })
          .catch((err) => {
            refreshTokenData(err, 2, options, params);
            reject(
              dispatch({
                type: failure,
                payload: err,
              })
            );
          });
      };

      return new Promise(promise);
    },
  put:
    (options, params = null) =>
    async (dispatch) => {
      const [success, failure] = options.types;
      const promise = (resolve, reject) => {
        var token = localStorage.getItem('token');
        if (token == null) {
          token = localStorage.getItem('admintoken');
        }
        axios({
          method: 'PUT',
          url: `${baseURL}${options.url}`,
          data: params,
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
          },
        })
          .then((res) => {
            resolve(
              dispatch({
                type: success,
                payload: res.data,
              })
            );
          })
          .catch((err) => {
            refreshTokenData(err, 3, options, params);
            console.log('err', err);
            reject(
              dispatch({
                type: failure,
                payload: err,
              })
            );
          });
      };

      return new Promise(promise);
    },
  patch:
    (options, params = null) =>
    async (dispatch) => {
      const [success, failure] = options.types;
      const promise = (resolve, reject) => {
        var token = localStorage.getItem('token');
        if (token == null) {
          token = localStorage.getItem('admintoken');
        }
        axios({
          method: 'PATCH',
          url: `${baseURL}${options.url}`,
          data: params,
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
          },
        })
          .then((res) => {
            resolve(
              dispatch({
                type: success,
                payload: res.data,
              })
            );
          })
          .catch((err) => {
            reject(
              dispatch({
                type: failure,
                payload: err,
              })
            );
          });
      };

      return new Promise(promise);
    },
  delete:
    (options, params = null) =>
    async (dispatch) => {
      const [success, failure] = options.types;
      const promise = (resolve, reject) => {
        var token = localStorage.getItem('token');
        if (token == null) {
          token = localStorage.getItem('admintoken');
        }
        axios({
          method: 'DELETE',
          url: `${baseURL}${options.url}`,
          data: params,
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
          .then((res) => {
            resolve(
              dispatch({
                type: success,
                payload: res.data,
              })
            );
          })
          .catch((err) => {
            refreshTokenData(err, 4, options, params);
            reject(
              dispatch({
                type: failure,
                payload: err,
              })
            );
          });
      };

      return new Promise(promise);
    },
};

const apiRefresh = {
  authLogin: (options, params = null) => {
    const promise = (resolve, reject) => {
      axios({
        method: 'POST',
        url: `${baseURL}${options.url}`,
        data: params,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return err;
        });
    };

    return new Promise(promise);
  },
  getLogout: (options) => {
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }
      return axios({
        method: 'GET',
        url: `${baseURL}${options.url}`,

        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((res) => {})
        .catch((err) => {});
    };

    return new Promise(promise);
  },
  get: (options) => {
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }
      return axios({
        method: 'GET',
        url: `${baseURL}${options.url}`,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    };
    return new Promise(promise);
  },
  getFile: (options) => {
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }
      return axios({
        method: 'GET',
        url: `${baseURL}${options.url}`,
        responseType: 'blob',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    };
    return new Promise(promise);
  },
  postWithFileRes: (options, params = null) => {
    const [success, failure] = options.types;
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }
      axios({
        method: 'POST',
        url: `${baseURL}${options.url}`,
        data: params,
        responseType: 'blob',
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    };

    return new Promise(promise);
  },
  post: (options, params = null) => {
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }
      axios({
        method: 'POST',
        url: `${baseURL}${options.url}`,
        data: params,
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    };

    return new Promise(promise);
  },
  put: (options, params = null) => {
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }
      axios({
        method: 'PUT',
        url: `${baseURL}${options.url}`,
        data: params,
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    };

    return new Promise(promise);
  },
  patch: (options, params = null) => {
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }
      axios({
        method: 'PATCH',
        url: `${baseURL}${options.url}`,
        data: params,
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {})
        .catch((err) => {});
    };

    return new Promise(promise);
  },
  delete: (options, params = null) => {
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }
      axios({
        method: 'DELETE',
        url: `${baseURL}${options.url}`,
        data: params,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    };

    return new Promise(promise);
  },
  getWithParams: (options, params = null) => {
    const promise = (resolve, reject) => {
      var token = localStorage.getItem('token');
      if (token == null) {
        token = localStorage.getItem('admintoken');
      }

      return axios({
        method: 'GET',
        url: `${baseURL}${options.url}`,
        params: params,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    };
    return new Promise(promise);
  },
};

const refreshTokenData = async (err, apiType, opt, param) => {
  if (
    err &&
    err.response &&
    err.response.status === 401 &&
    err.response.data &&
    err.response.data.code == 2
  ) {
    if (RefreshToken) {
      RefreshToken = false;

      const options = {
        url: 'v1/user/identity/RefreshToken',
      };

      options.types = [types.REFRESH_SUCCESS, types.REFRESH_FAILURE];
      const refreshToken = localStorage.getItem('refreshToken');
      const branchId = localStorage.getItem('selectedBranchId');
      if (refreshToken == null || refreshToken == 'undefined') {
        // No refresh token in storage — can't recover the session.
        handleSessionExpired();
        // Reset the guard so a later legitimate 401 can be processed if the
        // user re-authenticates within the same tab.
        RefreshToken = true;
        return;
      }
      var data = { refreshToken: refreshToken, branchId: branchId };

      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      var raw = JSON.stringify({
        refreshToken: refreshToken,
      });

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      fetch(`${baseURL}${options.url}`, requestOptions)
        .then((result) => result.json())
        .then((res) => {
          console.log(res);

          const admintoken = localStorage.getItem('admintoken');
          if (admintoken) {
            localStorage.removeItem('admintoken');
            localStorage.setItem('admintoken', res.accessToken);
          } else {
            localStorage.removeItem('token');
            localStorage.setItem('token', res.accessToken);
          }
          localStorage.removeItem('refreshToken');
          localStorage.setItem('refreshToken', res.refreshToken);
          if (apiType == 1) {
            apiRefresh.get(opt);
          } else if (apiType == 2) {
            apiRefresh.post(opt, param);
          } else if (apiType == 3) {
            apiRefresh.put(opt, param);
          } else if (apiType == 4) {
            apiRefresh.delete(opt, param);
          }
          for (let i = 0; i < CallStack.length; i++) {
            if (CallStack[i].apiType == 1) {
              apiRefresh.get(CallStack[i].opt);
            } else if (CallStack[i].apiType == 2) {
              apiRefresh.post(CallStack[i].opt, CallStack[i].param);
            } else if (CallStack[i].apiType == 3) {
              apiRefresh.put(CallStack[i].opt, CallStack[i].param);
            } else if (CallStack[i].apiType == 4) {
              apiRefresh.delete(CallStack[i].opt, CallStack[i].param);
            }
          }
          RefreshToken = false;
          CallStack = [];
          window.location.reload();
        })
        .catch(async (err) => {
          // Refresh token itself was rejected — this is the typical signal
          // that the account was signed in elsewhere and the server revoked
          // the previous session. Bounce to /login with a message.
          handleSessionExpired();
          RefreshToken = true;
          CallStack = [];
        });
    } else {
      var data = {
        apiType: apiType,
        opt: opt,
        param: param,
      };
      CallStack.push(data);
    }
  } else if (
    err &&
    err.response &&
    err.response.status === 401 &&
    err.response.data &&
    (err.response.data.code == 3 || err.response.data.code == 0) &&
    SessionDeath
  ) {
    SessionDeath = false;
    // Route through the same helper as the interceptor so the user sees a
    // single "session expired" toast and lands on /login (not a reload of
    // whatever authenticated page they were on).
    handleSessionExpired();
  }
  // else if(err && err.response && err.response.status === 404)
  // {
  //   message.info('No data found', 2)
  // }
  else if (err && err.response && err.response.status === 400) {
    if (opt.types[1] === 'GET_MAIL_BOX_FAILURE') {
      const data = err.response.data || {};
      const apiMessage = data.Detail || data.detail || data.message || data.Message;
      message.error(apiMessage || 'Sorry! Imap not integrated!', 10);
    }
  } else if (err && err.response && err.response.status === 500) {
    if (opt.types[1] === 'GET_MAIL_BOX_FAILURE') {
      const data = err.response.data || {};
      const apiMessage = data.Detail || data.detail || data.message || data.Message;
      message.error(apiMessage || 'Sorry! Imap not integrated!', 10);
    } else {
      message.error('Oops! Something went wrong! Please contact our Support Team!', 5);
    }
  }
};
export { api, apiRefresh, baseURL };
